import { observer } from 'mobx-react-lite'
import './BaseViewFieldTemplate.css'

/**
 * Ядро (FormField, режим перегляду) готує значення як `field.value || '-'`: число 0 і
 * `false` стають «—», а `true` React не малює зовсім. Повертаємо їх: 0 — як число,
 * перемикач — «Так»/«Ні», як у таблиці (Core utils). Готові значення (свої шаблони) не чіпаємо.
 */
export const restoreFalsyValue = (field, children) => {
    const value = field.value
    if (field.type === 'switch' && (children === '-' || typeof children === 'boolean')) {
        return value === true ? 'Так' : 'Ні'
    }
    if (typeof value === 'number' && Number.isFinite(value) && children === '-') {
        return String(value)
    }
    return children
}

/**
 * Поле в режимі перегляду: лейбл зліва, значення справа, рядки з тонким роздільником.
 * На вузькому екрані лейбл переходить над значення (див. CSS).
 */
export const BaseViewFieldTemplate = observer(({ field, children: rawChildren }) => {
    if (field === undefined) return null

    const children = restoreFalsyValue(field, rawChildren)

    // Визначаємо, чи є значення порожнім
    const isEmpty =
        children === null ||
        children === undefined ||
        children === '' ||
        children === '-' ||
        (typeof children === 'object' && children?.props?.dangerouslySetInnerHTML?.__html === '-')

    return (
        <div className="form-field-view">
            {field.label && <div className="field-view-label">{field.label}</div>}
            <div className={`field-view-value ${isEmpty ? 'is-empty' : ''}`}>{isEmpty ? '—' : children}</div>
        </div>
    )
})
